import { render } from "./pageNotFound.vue?vue&type=template&id=345c0a85&scoped=true"
import script from "./pageNotFound.vue?vue&type=script&lang=js"
export * from "./pageNotFound.vue?vue&type=script&lang=js"

import "./pageNotFound.vue?vue&type=style&index=0&id=345c0a85&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345c0a85"]])

export default __exports__